import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';

/** Table row that opens `to` when clicked anywhere; keyboard users use the RowLink inside it. */
export function ClickableRow({ to, children }: { to: string; children: ReactNode }) {
  const nav = useNavigate();
  return (
    <tr className="clickable" onClick={() => nav(to)}>
      {children}
    </tr>
  );
}

/** The focusable link in a ClickableRow (stops the row's own click from navigating twice). */
export function RowLink({ to, mono, children }: { to: string; mono?: boolean; children: ReactNode }) {
  return (
    <Link to={to} className={mono ? 'row-link mono' : 'row-link'} onClick={(e) => e.stopPropagation()}>
      {children}
    </Link>
  );
}
